<div class="warp-data-question">
        <img class="imgType" src="/assets/images/types/{{questionData?.question?.type?.image}}" />
    <div class="warp-right" [ngClass]="{'showCompare':showComparison$()}">
        <div class="data-question">{{questionData?.question | questionTitle}}</div>
        <div class="comments" *ngIf="filterRecipients$()==undefined">
            <p>{{questionData?.comments}}</p>
            <p translate>data.comments</p>
        </div>
        <div class="all" *ngIf="filterRecipients$()==undefined else singleRecipient">
            <p class="tag" *ngIf="showComparison$()" translate>data.current</p>
            <div class="warp-diagram" *ngFor="let optionData of options ,let i= index">
                <div class="hover">
                    <div class="circle" *ngIf="optionData.recipients.length != 0 else emptyCircle">
                        <p class="recipients-num">{{optionData.recipients.length}}</p>
                    </div>
                    <div class="warp-tooltip">
                        <que-contact-tooltip class="tooltip" [title]="'dataUsers'" [color]="'#B7C7FC'"
                            [recipients]="optionData.recipients">
                        </que-contact-tooltip>
                    </div>
                </div>
                <que-range-diagram class="diagram" [percentage]="optionData.percent" [value]="optionData.value"
                    [isCurrent]="true" [wasChange]="optionData.wasChange"></que-range-diagram>
            </div>
        </div>
        <ng-container  *ngIf="showComparison$()">
            <div class="all" *ngIf="filterRecipients$()==undefined else singleRecipientPrevious">
                <p class="tag" translate>data.previous</p>
                <div class="warp-diagram" *ngFor="let optionData of options ,let i= index">
                    <div class="hover">
                        <div class="circle" *ngIf="optionData.recipients.length != 0 else emptyCircle">
                            <p class="recipients-num">{{optionData.recipientsSource.length}}</p>
                        </div>
                        <div class="warp-tooltip">
                            <que-contact-tooltip class="tooltip" [title]="'dataUsers'" [color]="'#B7C7FC'"
                                [recipients]="optionData.recipientsSource">
                            </que-contact-tooltip>
                        </div>
                    </div>
                    <que-range-diagram class="diagram" [percentage]="optionData.percentSource"
                        [value]="optionData.value"></que-range-diagram>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #singleRecipient>
    <div class="all filter">
        <p class="tag" *ngIf="showComparison$()" translate>data.current</p>
        <div *ngFor="let optionData of options ,let i= index" class="warp-diagram">
            <que-range-diagram class="diagram" [percentage]="optionData.percent" [value]="optionData.value"
                [isCurrent]="true" [wasChange]="optionData.wasChange" [inFilter]="true"></que-range-diagram>
        </div>
    </div>
</ng-template>
<ng-template #singleRecipientPrevious>
    <div class="all filter">
        <p class="tag" *ngIf="showComparison$()" translate>data.previous</p>
        <div *ngFor="let optionData of options ,let i= index" class="warp-diagram">
            <que-range-diagram class="diagram" [percentage]="optionData.percentSource" [value]="optionData.value"
              [wasChange]="optionData.wasChange" [inFilter]="true"></que-range-diagram>
        </div>
    </div>
</ng-template>
<ng-template #emptyCircle>
    <div class="circle empty"></div>
</ng-template>